<template>
  <Allow
      v-if="!hidden"
      title="Организатор не может связаться с Вами!"
      content="Включите оповещения о выставлении счета и выдаче заказа"
      :hideable="true"
      @action="action"
      @hide="hidden = true"
  ></Allow>
</template>

<script>
import Allow from '@/components/Allow'
import {enableRequiredPermissions} from '@/composables/user'

export default {
  name: 'AllowPermissions',
  components: {Allow},
  data () {
    return {
      hidden: false
    }
  },
  methods: {
    action: enableRequiredPermissions
  }
}
</script>

<style scoped>

</style>